
<div class="dataGrid">

    <kendo-grid #reportGrid [data]="data" class="reviewGrid" [height]="900" [loading]="loading"  (excelExport)="excelExported($event)">
        <ng-template kendoGridToolbarTemplate>
            <kendo-grid-spacer></kendo-grid-spacer>
            <app-mcl-button *ngIf="pdfExport" id="but-export" (buttonPressed)="exportToPDF(reportGrid)" text="Export to PDF"
            [svgIcon]='filePdfIcon'
            primary="true"></app-mcl-button>
            <app-mcl-button id="but-export-excel" (buttonPressed)="exportToExcel(reportGrid)"  [svgIcon]="fileExcelIcon"  primary="true" text="Export to Excel"></app-mcl-button>
        </ng-template>

        <kendo-grid-column *ngFor="let col of columns" [field]="col.key" [format]="col.format" [title]="col.title" class="reportFormat" [autoSize]="true"  >
        </kendo-grid-column>

        <kendo-grid-excel [fileName]="excelExportOptions.exportName" [fetchData]="exportAllData">

            <kendo-excelexport-column *ngFor="let col of columns" [field]="col.key" [title]="col.title" class="reportFormat"  ></kendo-excelexport-column>

        </kendo-grid-excel>
        <kendo-grid-pdf [fileName]="filename" [author]="'McLane'" [producer]="'McLane'" [allPages]="true" paperSize="A4" [repeatHeaders]="false" [scale]="0.5" [landscape]="landscape" >

            <kendo-grid-pdf-margin top="1.5cm" left="1cm" right="1cm" bottom="1cm"></kendo-grid-pdf-margin>
            <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
                <ng-template [ngTemplateOutlet]="headerTemplate"></ng-template>
            </ng-template>

        </kendo-grid-pdf>

    </kendo-grid>
</div>
<div kendoDialogContainer></div>
